import {
  GET_MEMBERS,
  GET_MEMBERS_SUCCESS,
  GET_MEMBERS_FAIL,
  GET_MEMBERS_DETAILS,
  GET_MEMBERS_DETAILS_SUCCESS,
  GET_MEMBERS_DETAILS_FAIL,
  CREATE_MEMBERS,
  CREATE_MEMBERS_SUCCESS,
  CREATE_MEMBERS_FAIL,
  UPDATE_MEMBERS,
  UPDATE_MEMBER_SUCCESS,
  UPDATE_MEMBER_FAIL,
  DELETE_MEMBERS,
  DELETE_MEMBERS_SUCCESS,
  DELETE_MEMBERS_FAIL,
  GET_USERS,
  GET_USERS_FAIL,
  GET_USERS_SUCCESS,
  CREATE_USERS,
  UPDATE_USERS,
  DELETE_USERS,
  CREATE_USERS_FAIL,
  UPDATE_USERS_FAIL,
  DELETE_USERS_FAIL,
  CREATE_USERS_SUCCESS,
  UPDATE_USERS_SUCCESS,
  DELETE_USERS_SUCCESS,
  GET_USERS_WITH_CROSS_BRANCH,
  GET_USERS_WITH_CROSS_BRANCH_SUCCESS,
  GET_USERS_WITH_CROSS_BRANCH_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  members: {
    members: [],
    total: "",
    page: "",
  },
  memberDetails: {},
  error: {},
  loading: false,
  users: {
    users: [],
    total: "",
    page: "",
  },
  // Separate state for cross-branch users (admin only)
  usersWithCrossBranch: {
    users: [],
    total: "",
    page: "",
  },
  crossBranchLoading: false,
  crossBranchError: {},
}

const Members = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Users - This line cannot be edited or removed
    case GET_MEMBERS:
    case GET_MEMBERS_DETAILS:
    case CREATE_MEMBERS:
    case UPDATE_MEMBERS:
    case DELETE_MEMBERS:
    case GET_USERS:
    case CREATE_USERS:
    case UPDATE_USERS:
    case DELETE_USERS:
      return {
        ...state,
        loading: true,
      }

    // Cross-branch users loading
    case GET_USERS_WITH_CROSS_BRANCH:
      return {
        ...state,
        crossBranchLoading: true,
      }
      Members
    case DELETE_MEMBERS_FAIL:
    case GET_MEMBERS_FAIL:
    case GET_MEMBERS_DETAILS_FAIL:
    case UPDATE_MEMBER_FAIL:
    case CREATE_MEMBERS_FAIL:
    case GET_USERS_FAIL:
    case CREATE_USERS_FAIL:
    case UPDATE_USERS_FAIL:
    case DELETE_USERS_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    // Cross-branch users error
    case GET_USERS_WITH_CROSS_BRANCH_FAIL:
      return {
        ...state,
        crossBranchError: action.payload,
        crossBranchLoading: false,
      }

    case GET_MEMBERS_SUCCESS:
      return {
        ...state,
        members: action?.payload,
        error: {},
        loading: false,
      }

    case GET_MEMBERS_DETAILS_SUCCESS:
      return {
        ...state,
        usersDetails: action.payload,
        error: {},
        loading: false,
      }

    case CREATE_MEMBERS_SUCCESS: {
      const { newMemberData } = action.payload
      const formattedStaff = {
        _id: newMemberData?._id,
        name: newMemberData?.name,
        email: newMemberData?.user?.email,
        phone: newMemberData?.user?.phone,
        memberRole: newMemberData?.user?.memberRole, // mapping designation to memberRole
        createdAt: newMemberData?.createdAt,
      }
      return {
        ...state,
        members: {
          ...state?.members,
          members: [formattedStaff, ...state?.members?.members],
          total: Number(state.members.total || 0) + 1,
        },
        users: {
          ...state?.users,
          users: [formattedStaff, ...state?.users?.users],
          total: Number(state.users.total || 0) + 1,
        },
        usersDetails: action.payload,
        error: {},
        loading: false,
      }
    }

    case UPDATE_MEMBER_SUCCESS:
      return {
        ...state,
        members: {
          ...state.members,
          members: state.members.members.map(member =>
            member._id === action.payload._id
              ? { ...member, ...action.payload }
              : member
          ),
        },
        users: {
          ...state.users,
          users: state.users.users.map(user =>
            user._id === action.payload._id
              ? { ...user, ...action.payload }
              : user
          ),
        },
        usersDetails: action.payload,
        loading: false,
        error: {},
      }

    case DELETE_MEMBERS_SUCCESS:
      return {
        ...state,
        members: {
          ...state?.members,
          members: state?.members?.members?.filter(
            member => member._id !== action?.payload?._id
          ),
          total: Math.max(0, Number(state.members.total) - 1),
        },
        users: {
          ...state?.users,
          users: state?.users?.users?.filter(
            user => user._id !== action?.payload?._id
          ),
          total: Math.max(0, Number(state.users.total) - 1),
        },
        error: {},
        loading: false,
      }
    case GET_USERS_SUCCESS:
      return {
        ...state,
        users: action?.payload,
        error: {},
        loading: false,
      }
    case CREATE_USERS_SUCCESS:
      return {
        ...state,
        members: action?.payload,
        error: {},
        loading: false,
      }
    case UPDATE_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload,
      }
    case DELETE_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload,
      }

    // Cross-branch users success
    case GET_USERS_WITH_CROSS_BRANCH_SUCCESS:
      return {
        ...state,
        usersWithCrossBranch: action?.payload,
        crossBranchError: {},
        crossBranchLoading: false,
      }

    default:
      return state
  }
}

export default Members
